export default __webpack_public_path__ + "static/media/single-corner-rectangle.98115ce2.svg";